<template>
  <div>
    <div class="jc-page-header">
      <h1>
        <a @click="cancel">
          <i class="jc-icon-my-angle-left-bold"></i>
        </a>
        {{ $t('券额转赠')}}
      </h1>
    </div>
    <div class="jc-page-content couponLoading quotaInfo" style="background:#ebf1f5">
      <div class="jc-panel jc-panel-padding">
        <detail-info
          :quotaNumber="quotaNumber"
          @getDetail="getDetail"
          :type="'resend'"
          @noPermission="noPermission"
        ></detail-info>
        <div class="jc-section">
          <div class="jc-section-header">
            <h3 class="jc-section-title">{{ $t('转赠信息')}}</h3>
          </div>
          <div class="jc-section-content">
            <div class="tip-earlyWarning mb10">
              {{ `1. ${$t('券额转赠功能无回收功能，请谨慎操作')}`}}
              <br />
              {{ `2. ${$t('券额操作为敏感操作，需要验证用户信息')}`}}
              <br />
            </div>
            <issue-template
              ref="issueTemplate"
              :type="'resend'"
              :restriction="restriction"
              :time="time"
              :balance="detail.balance"
              @firstStepData="firstStepData"
              @cancel="cancel"
              @selectAccount="selectAccount"
            ></issue-template>
          </div>
        </div>
      </div>
    </div>
    <issue-account ref="issueAccount" @selectedName="selectedName" :isResend="true"></issue-account>
    <validate-dialog ref="validateDialog" :type="'resend'" :info="info" @submit="submit" :security="security"></validate-dialog>
  </div>
</template>

<script>
import getTranslation from '@/i18n/getTranslation'
import { quotaResend, describeConsoleSecurity } from '@/api/coupon-api.js'
import DetailInfo from './model/DetailInfo.vue'
import IssueTemplate from '@/views/components/IssueTemplate.vue'
import ValidateDialog from '@/views/components/ValidateDialog.vue'
import IssueAccount from '@/views/components/IssueAccount'
import quotaPermissionMixin from '@/mixins/quotaPermission-mixin.js'
export default {
  name: 'quotaCouponIssue',
  components: {
    DetailInfo,
    IssueTemplate,
    ValidateDialog,
    IssueAccount
  },
  mixins: [quotaPermissionMixin],
  data() {
    return {
      detail: {},
      quotaNumber: (this.$route.query && this.$route.query.number) || '',
      tableData: [],
      info: {},
      time: '',
      restriction: 0, // 是否限制用户
      security: 1 //是否进行短信验证
    }
  },
  methods: {
    getDetail(val) {
      this.detail = val
      // 判断是相对时间还是绝对时间
      if (val.timeType === 2) {
        this.time = `${val.relativeTime} ${getTranslation('天')}`
      } else {
        this.time = `${val.validStartTime}-${val.validEndTime}`
      }
    },
    firstStepData(val) {
      this.info = val
      this.$refs.validateDialog.validateDialog = true
    },
    cancel() {
      this.$router.push({ path: '/cost/quota-coupon' })
    },
    selectAccount() {
      this.$refs.issueAccount.issueAccount = true
    },
    selectedName(val) {
      this.info.pointUser = val
      this.$refs.issueTemplate.validateFuc(val)
    },
    async getSecurity() {
      let {
        body: { result }
      } = await describeConsoleSecurity()
      this.security = result && result.data
    },

    // 发放代金券
    async submit(val) {
      await quotaResend({ quotaNumber: this.quotaNumber, ...val })
      this.$notify.success(getTranslation('发放成功'))
      this.$refs.validateDialog.validateDialog = false
      this.$router.push({ path: '/cost/quota-coupon' })
    }
  },
  created() {
    this.getRestriction()
    this.getSecurity()
  }
}
</script>
